const UNKNOWN_TAG = 'Unknown Tag';
export default UNKNOWN_TAG;
